<template>
   <footer id="bp-footer" class="container-fluid">
        <div class="container h-100">
            <div class="row align-items-start justify-content-center h-50">
                <div class="col-6 col-lg-3">
                    <img :src="images[0]" class="img-fluid">
                </div>
                <div class="col-12 text-center">
                    <h5 class="address">{{ address }}</h5>
                </div>
            </div>
            <div 
                v-if="qr.showCode"
                class="row d-flex align-items-center justify-content-center qr_code_wrapper"
            >
                <img :src="qr.image" class="setImageWidth" />
            </div>
            <div class="row d-flex align-self-end h-50">

                <ul class="list-group list-group-horizontal d-flex align-items-end justify-content-center bp-list-group">
                    <li class="list-group-item" v-for="(social, index) in links" :key="index">
                        <a :href="social.url" target="_blank">
                            <i class="fa-brands" :class="social.icon"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </footer>
</template>

<script>

    // load assets
    import companyLogo from "../../assets/bellingen_property_rev.png";
    import QRCode from "../../assets/qr_code.png"

    
    export default ( {
        name: "footerComponent",
        data() {
            return {
                address: "Bellingen NSW 2454",
                links: {
                    'facebook': {
                        icon: "fa-facebook-f",
                        url: "https://www.facebook.com/BellingenProperty/"
                    },
                    'youtube': {
                        icon: "fa-youtube",
                        url: "https://www.youtube.com/channel/UCpzBcT9VCqCeCjOuM5-fgIQ"
                    },
                    'instagram': {
                        icon:   "fa-instagram",
                        url:    "https://www.instagram.com/bellingenproperty/"
                    }
                },
                images: [
                    companyLogo,
                ],
                qr: {
                    showCode: true,
                    image: QRCode
                }
            }
        }
   });
</script>

<style lang="scss" scoped>
     // global vars
    @import "../../scss/vars.one3design.scss";

    // global mixins
    @import "../../scss/mixins.one3design.scss";

    #bp-footer {
        background-color:$black;
        color:$white;
        min-height: 500px;
        padding-bottom: 3em;
        padding-top: 3em;
        position: relative;
        .address {
            letter-spacing: .025em;
            margin-top: 2em;
        }

        .setImageWidth {
            margin: 30px 0;
            max-width: 200px;
        }
        .list-group {
            .list-group-item {
                background-color:transparent;
                border:0;
                svg, i {
                    color:$color_main;
                    font-size:1.5em;
                }
            }
        }
        @media screen and ( max-width: $mobile ) {
            
        }
    }

</style>
